export type WeeklyViewerAccessContextInput = {
  profileLoaded: boolean;
  department: unknown;
  teamId: unknown;
  updatedAt?: unknown;
};

const normalizeAccessContextPart = (value: unknown): string =>
  String(value ?? '').trim();

/**
 * Returns a stable cache discriminator only after the viewer identity that
 * affects weekly-report visibility has been loaded completely.
 *
 * `null` intentionally means "do not search, restore, or save results".
 */
export const buildWeeklyViewerAccessContextKey = ({
  profileLoaded,
  department,
  teamId,
  updatedAt,
}: WeeklyViewerAccessContextInput): string | null => {
  if (!profileLoaded) return null;

  const normalizedDepartment = normalizeAccessContextPart(department);
  const normalizedTeamId = normalizeAccessContextPart(teamId);
  if (!normalizedDepartment || !normalizedTeamId) return null;

  return JSON.stringify({
    department: normalizedDepartment,
    teamId: normalizedTeamId,
    updatedAt: normalizeAccessContextPart(updatedAt),
  });
};

export const isWeeklyViewerAccessContextReady = (
  input: WeeklyViewerAccessContextInput
): boolean => buildWeeklyViewerAccessContextKey(input) !== null;
